import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './app/App';
import { RecoveryApp } from './app/RecoveryApp';
import { registerOffline } from './platform/offline';
import './styles/tokens.css';
import './styles/app.css';

const recovery=document.querySelector('meta[name=hwakdap-mode]')?.getAttribute('content')==='recovery';
createRoot(document.getElementById('root')!).render(recovery?<RecoveryApp/>:<StrictMode><BrowserRouter><App /></BrowserRouter></StrictMode>);

if(!recovery)registerOffline();
